export const bannerData = [
    {link: '', path: require('../../assets/image/common/banner.png') , path_m: require('../../assets/image/common/banner_m.png') , remark: ''},
    {link: '', path: require('../../assets/image/common/banner.png') , path_m: require('../../assets/image/common/banner_m.png') , remark: ''},
    {link: '', path: require('../../assets/image/common/banner.png') , path_m: require('../../assets/image/common/banner_m.png') , remark: ''},
]
